// Core
import { useState, useCallback, useMemo } from 'react';
import { useQuery } from 'react-query';
import { useParams, useHistory } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';

// Components
import EditContent from './components/EditContent';

const Edit = ({dataUser}) => {
  const history = useHistory();
  const { id } = useParams();
  const [newObjectErrors, setNewObjectErrors] = useState([]);
  const [newObject, setNewObject] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = useState([]);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [errorCard, setErrorCard] = useState();

  useMemo(() => { setErrorCard(); }, [newObject]);

  const { isLoading, isError } = useQuery({
    queryKey: [id],
    refetchOnWindowFocus: false,
    refetchOnError: false,
    queryFn: async () => {
      if (id === 'new') {
        setNewObject({});
      } else {
        const response = await apiService.getGroup({id});
        setNewObject(response.data);
      }
      return true;
    }
  });

  const handleCreateObject = useCallback(async () => {
    setIsLoadingButton(true);
    if (newObjectErrors.length > 0) {
      setIsLoadingButton(false);
      return;
    }

    if (Object.keys(newObject).length === 0) {
      setIsLoadingButton(false);
      return;
    }

    let objectId = newObject.id;
    const data = { ...newObject };

    if (newObject.id) {
      try {
        delete data.image;
        const response = await apiService.updateGroup(data);
        if(response.data === false || response.statusCode !== 200){
          setErrorCard(response.message);
          setIsLoadingButton(false);
          return;
        }
      } catch(e){
        setErrorCard(true);
        setIsLoadingButton(false);
        return;
      }
    } else {
      try {
        delete data.image;
        const response = await apiService.createGroup(data);
        if(response.data === false || response.statusCode !== 200){
          setErrorCard(response.message);
          setIsLoadingButton(false);
          return;
        }

        objectId = response?.data?.id;
      } catch(e){
        setErrorCard(true);
        setIsLoadingButton(false);
        return;
      }
    }

    if (selectedFile) {
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('itemType', 'group');
      formData.append('sync', true);
      formData.append('itemId', objectId);

      try {
        const response = await apiService.upload(formData); 
        console.log('File uploaded successfully:', response.data);
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    }

    setIsLoadingButton(false);

    setNewObject({});
    history.push('/group-profile');
  }, [history, newObject, newObjectErrors, selectedFile]);

  const handleDelete = async (item) => {
    try {
      await apiService.deleteGroup(item);
      setNewObject({});
      history.push('/group-profile');
    } catch (error) {}
  };

  return (isError ? 
    <div>Not Found</div> : isLoading ? 
    <div>Loading...</div> : 
    <EditContent
      isEditable={'true'}
      dataUser={dataUser}
      isLoadingButton={isLoadingButton}
      newObject={newObject} 
      newObjectErrors={newObjectErrors} 
      setNewObject={setNewObject} 
      setSelectedFile={setSelectedFile}
      selectedFiles={selectedFiles}
      setNewObjectErrors={setNewObjectErrors} 
      handleCreateObject={handleCreateObject} 
      errorCard={errorCard}
      handleDelete={handleDelete}
    />);
};

export default Edit;